import { render, staticRenderFns } from "./changeOriginalTid.vue?vue&type=template&id=edc03ddc"
import script from "./changeOriginalTid.vue?vue&type=script&lang=js"
export * from "./changeOriginalTid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports